import { render, staticRenderFns } from "./PayModal.vue?vue&type=template&id=84c479d6&scoped=true&"
import script from "./PayModal.vue?vue&type=script&lang=js&"
export * from "./PayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c479d6",
  null
  
)

export default component.exports